module.exports = __webpack_public_path__ + "img/logo_foot.ff7f18e2.png";